import React, { useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { createEndPoint, ENDPOINTS } from '../apis/Api';
import { validatePassword } from '../components/PasswordValidator';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function Register() {
    const { setAuth } = useAuth();
    
    const [username, setUsername] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [birthday, setBirthday] = React.useState(new Date());
    const [password, setPassword] = React.useState('');
    const [passwordRepeated, setPasswordRepeated] = React.useState('');
    const [avatarFileName, setAvatarFileName] = useState('./img/blank-avatar.jpg');
    const [avatarFile, setAvatarFile] = useState(null);

    const navigate = useNavigate();

    const handleChange = (e) => {
        if (e.target.files[0]) {
            var avatarFile = e.target.files[0];
            setAvatarFileName(URL.createObjectURL(avatarFile));
            setAvatarFile(avatarFile);            
        }
    }

    // set errors
    const [errors, setErrors] = useState({});

    const handleSubmit = async (e) => {
        // prevent default behavior of the form (prevent reloading)
        e.preventDefault();

        setErrors({});

        const data = {
            username: username,
            email: email,
            password: password,
            birthday: birthday,
            avatarFileName: avatarFileName,
            avatarFile: avatarFile
        };

        // error message
        var msg = '';

        const formData = new FormData();
        formData.append('username', data.username);
        formData.append('email', data.email);
        formData.append('password', data.password);
        //formData.append('birthday', data.birthday);
        const birthdayValue = (birthday instanceof Date)
            ? birthday.toISOString().substring(0, 10)
            : (typeof birthday === 'string' ? birthday : '');
        formData.append('birthday', birthdayValue);
        formData.append('avatarURL', data.avatarURL);
        formData.append('avatarFile', data.avatarFile);

        if (validate()) {
                createEndPoint(ENDPOINTS.userRegister)
                .post(formData)
                .then(res => {
                    //log-out before redirect
                    setAuth({});
                    // redirect on success
                    navigate('/register-status');
                })
                .catch(err => {
                    if (!err?.response) {
                        msg = 'Server is not responding!';
                        console.log(msg);
                        errors.server = msg;
                    }
                    else if (err?.response.status === 400)
                    {
                        msg = 'Bad request!';
                        console.log(msg);
                        errors.server = msg;
                    }
                    else if (err?.response.status === 409)
                    {
                        msg = 'The user with this username already exits!';
                        console.log(msg);
                        errors.server = msg;
                    }
                    else {
                        msg = 'Sign-up was unsuccessful!';
                        console.log(msg);
                        errors.server = msg;
                    }
                })
                .finally(() => {
                    setErrors(errors);
                })
        }   
    }

    const validate = () => {
        var errors = {};
        const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passMinLength = 8;

        // login validation
        errors.username = username !== '' ? '' : 'Invalid username!';

        // email validation
        errors.email = regEx.test(email) ? '' : 'Invalid email!';
        
        // birthday validation
        // errors.birthday = birthday !== '' ? '' : 'Invalid birthday!';

        // password validation
        errors.password = (validatePassword(password, passMinLength).length === 0) ? '' : validatePassword(password, passMinLength);
        
        // password confirmed
        errors.passwordRepeated = password === passwordRepeated ? '' : 'Password have to be same!';

        setErrors(errors);

        return Object.values(errors).every(item => item === '');
    }

    return (
        <div>
            <span>
                <label class='header h2 mt-5'>Register</label>
                <i class='bi bi-person-square h2 me-2'></i>
            </span>
            <div class='register'>
                <form onSubmit={ handleSubmit }>
                    <div class='register-form'>
                        <label class='register-label'>
                            Login
                        </label>
                        <input 
                            type='text' 
                            class='form-control mb-2 ms-2' 
                            placeholder='login' 
                            onChange = { (e) => setUsername(e.target.value) }
                            maxLength={50}  
                        />
                        { errors.username && <div class='error-text'> { errors.username } </div> }
                        <label class='register-label'>
                            Email
                        </label>
                        <input 
                            type='email' 
                            class='form-control mb-2 ms-2' 
                            placeholder='example@mail.com' 
                            onChange = { (e) => setEmail(e.target.value) }
                            maxLength={50}  
                        />
                        { errors.email && <div class='error-text'> { errors.email } </div> }
                        <label style={{ display: 'none' }} class='register-label'>
                            Birthday
                        </label>
                        <input 
                            style={{ display: 'none' }} 
                            type='date' 
                            class='form-control mb-2 ms-2' 
                            placeholder='01.01.2001' 
                            onChange = { (e) => setBirthday(e.target.value) }
                            maxLength={50}  
                        />
                        { errors.birthday && <div class='error-text'> { errors.birthday } </div> }
                        <label class='register-label'>
                            Password
                        </label>
                        <input 
                            type='password' 
                            class='form-control mb-2 ms-2' 
                            placeholder='' 
                            onChange = { (e) => setPassword(e.target.value) } 
                            maxLength={50}
                        />
                        {
                            errors.password &&
                            errors.password.map((error) => (
                                <div class='error-text'>
                                    <span>{ error }</span>
                                </div>
                            ))
                            
                        }
                        <label class='register-label'>
                            Repeat Password
                        </label>
                        <input 
                            type='password' 
                            class='form-control mb-2 ms-2' 
                            placeholder='' 
                            onChange = { (e) => setPasswordRepeated(e.target.value) }
                            maxLength={50}
                        />
                        { passwordRepeated && <div class='error-text'> { errors.passwordRepeated } </div>}
                        { errors.server && <div class='error-message' > { errors.server } </div> }
                        <label class='register-label'>
                            Add avatar
                        </label>
                        <label htmlFor='fileInput' class='register-label'>
                            <i class="register-add-img-icon bi bi-folder-plus h2 me-2"></i>
                        </label>
                        <input type='file' id='fileInput' style={{ display: 'none' }} onChange={ handleChange } />
                        <img src={ avatarFileName } 
                            alt=''
                        />
                    </div>
                    <button class='btn btn-outline-dark me-2 mt-5' type='submit'>Sign up</button>
                </form>
            </div>
        </div>    
    );
}